/**
 * Created by mauget on 10/4/16.
 */

import { View } from 'backbone';
import {Model}  from 'backbone';
import formSaveService     from 'FormSaveService';
import notificationService from 'NotificationService';
import ConfirmDialogView    from 'common-views/ConfirmDialogView.js';
import restService          from 'RestService.js';
import listService              from 'ListService.js';
import constants            from 'Constants.js';
import undoService      from 'UndoService.js';
import eventBus         from 'EventBus.js';
import PopupWrapperService from 'PopupWrapperService';
import Spinner from 'spin/spin';
import util             from 'util/Util';
import userService from 'UserService';
import commonService from "CommonService.js";
import appService from "AppService.js";
import reportService from 'ReportService.js';
// Pull common handlers of main menus up here.
class BaseMenuView extends View {


    initialize( opts ) {

        this.listenTo( eventBus, 'undoCacheEvent', this.setUndoRedoAccess);
        eventBus.on( constants.EV_SAVE_CURRENT_FORM, this.handleSaveCurrentFormEvent,this);

    }

    // Example of inflated metadata. id is formID.
    // <ResponseMetaData id="16260" version="0.1" docVersion="1"><Fields/></ResponseMetaData>

    //==========================================================
    // Listens for save current form event. Intended to satisfy
    // a keyboard hotkey event.
    // This method is a proxy client of this FormSave service.
    //==========================================================
    handleSaveCurrentFormEvent( promiseHandles  ){
        // Route to save form or save report according to what's loaded
        const
            isLayout = listService.docType === constants.DOC_TYPE_FORM,
            isReport = listService.docType === constants.DOC_TYPE_REPORT;

        if (isLayout || isReport) {
            const saveFn = isLayout ? this.saveForm : this.saveReport;

            const savePromise = saveFn.call(this, null, false, false);
            if (promiseHandles && promiseHandles.resolve && promiseHandles.reject) {
                savePromise
                    .then(result => {
                        promiseHandles.resolve(result);
                    })
                    .catch(error => {
                        promiseHandles.reject(error);
                    });
            }

        } else {
            console.log(`ctrl-s ignored: no current layout or report`);
            if (promiseHandles && promiseHandles.reject) {
                promiseHandles.reject(new Error("No app or report to save."));
            }
        }
    }

    showDebugOrPreview(preview,debug){
        const self = this;
        if (preview) {
            window.setTimeout(self.previewForm, 1000);
        } else if (debug) {
            window.setTimeout(self.debugForm, 1000);
        }
    }

    undo(){
        undoService.undo();
        this.setUndoRedoAccess();  
    }

    redo(){
        undoService.redo();
        this.setUndoRedoAccess();
    }

    setUndoRedoAccess() {
        $('#designerUndo').removeClass('disabled pf-disable disabledLink');
        $('#designerRedo').removeClass('disabled pf-disable disabledLink');

        if (!undoService.hasUndo()) {
            $('#designerUndo').addClass('disabled pf-disable disabledLink');
        }

        if (!undoService.hasRedo()) {
            $('#designerRedo').addClass('disabled pf-disable disabledLink');
        }
        
        this.model.set({undoText: undoService.undoText, redoText: undoService.redoText}, {silent:true});
        const undoEl = $('#designerUndo')[0];
        if (undoEl) {
            undoEl.innerHTML = undoService.undoText;
        }

        const redoEl = $('#designerRedo')[0];
        if (redoEl) {
            redoEl.innerHTML = undoService.redoText;
        }

    }

    updateAppName() {
        return new Promise((resolve, reject) => {
            const currentForm = listService.currentForm;
            const formId = currentForm.model.get("id");
            const appName = currentForm.model.get("formNameFromResponse");
            const newAppName = listService.formBase.name;

            if (newAppName && newAppName !== "null" && newAppName !== appName) {

                //Update form name
                restService.updateFormName(formId, newAppName).then(data => {

                    const validatedName = data.RESULT.RESPONSE.Name;
                    currentForm.model.set("formNameFromResponse", validatedName);
                    resolve("ok");

                }, err => {
                    console.log(data.msg, 'error');
                    notificationService.error("Error saving app. The app name should not contain invalid characters.");
                    resolve("error changing name");
                });
            }
            else{
                resolve("ok");
            }           
        });
    }

    //================================================================================
    // Saves the current layout editor form, as defined by listService state
    //================================================================================
    saveForm(ev, preview=false, debug=false, context = null, publish = false) {
        formSaveService.handleSave({ saveType: 'save', preview, debug, context, publish }, this);
    }

    saveFormNewVersion(ev, preview=false, isMobileDirty, spinner, debug = false, publish = false) {
        formSaveService.handleSave({ saveType: 'newVersion', preview, isMobileDirty, debug, publish }, this);
    }

    saveFormAsNew() {
        formSaveService.handleSave({ saveType: 'newApp' }, this);
    }

    publish() {
        if (listService.docType === constants.DOC_TYPE_FORM) {
            this.saveForm(null, false, false, null, true);
        }else if (listService.docType === constants.DOC_TYPE_REPORT){
            this.saveReport(null, false, false, this, true);
        }
    }

    publishForm() {
        let appId = listService.formBase.id;
        commonService.getModel(appId, "app", appService.createNewModel).then((appModel)=>{
            commonService.publishValidations(appModel, "app");
        });
    }

    publishReport(){
        let reportId = listService.formBase.id;
        commonService.getModel(reportId, "report", reportService.createNewModel).then((reportModel)=>{
            commonService.publishValidations(reportModel, "report");
        }); 
    }

    preview() {
        if (listService.docType === constants.DOC_TYPE_FORM) {
            this.saveForm(null, true);
        }

        if (listService.docType === constants.DOC_TYPE_REPORT) {
            this.saveReportForPreview(null, true);
        }
    }

    previewForm() {
        const previewUrl = restService.getPreviewLink();
        // window.open(previewUrl);
        PopupWrapperService.windowOpen( previewUrl ) ;
    }

    debug() {
        if (listService.docType === constants.DOC_TYPE_FORM) {
            this.saveForm(null, false, true);
        }

        if (listService.docType === constants.DOC_TYPE_REPORT) {
            this.saveReportForPreview(null, false, true);
        }
    }

    debugForm() {
        const debugUrl = restService.getDebugLink();
        // window.open(debugUrl);
        PopupWrapperService.windowOpen( debugUrl ) ;
    }

    saveReportForPreview(ev, preview, debug = false) {
        let currentReport = listService.currentForm;
        currentReport.model.set('isYodaFile',true,{silent:true});

        // Save report before preview
        const self = this;
        formSaveService.saveCurrentReport({ isNewVersion: false, isPreview: false }).then(msg => {
            // Save for preview
            if (!this.hasFormErrors()) {
                self.updateAppName().then(response => {
                    formSaveService.saveCurrentReport({ isNewVersion: false, isPreview: true }).then(msg => {
                        self.showDebugOrPreview(preview, debug);
                    }, (errMsg) => {
                        notificationService.error(errMsg);
                    });
                });
            }
        }, ( errInfo ) =>{
            if (parseInt(errInfo[1]) === 16) {

                let confirmText = 'You cannot save over a published version <br /><br />';
                confirmText += 'Would you like to save your changes as a new version?';

                const confirmView = new ConfirmDialogView({
                    model: new Model({
                        text: confirmText,
                        success: () => {
                            self.saveReportNewVersion(preview ? self.previewForm : self.debugForm);
                        },
                        title: 'Report already published'
                    })
                });

                confirmView.render();

            } else {
                notificationService.error( errInfo[0] );
            }
        });
    }

    hasFormErrors () {
        let generalErrors = [];
        let gridErrors = [];

        let isDataSourceEmpty = (dataSource) => {
            let hasNoDataSource = _.filter([null, "none", "", undefined], value => value === dataSource); 

            return hasNoDataSource.length === 0;
        };

        let validateFields = (dataSource, dataToEvaluate, objectName) => {
            if (isDataSourceEmpty(dataSource) && (!dataToEvaluate || dataToEvaluate === 'none')) {
                generalErrors.push(objectName);
            }
        };

        const validateCrossTabs = (dataSource, columnGroup, objectName, isGrid = false) => {
          
            if (isDataSourceEmpty(dataSource)) {
                const callBack = isGrid ?
                    column => !column.fieldId || column.fieldId === 'none' :
                    column => !column.Properties.fieldId || column.Properties.fieldId === 'none';

                const columnsFound = _.filter(columnGroup, callBack);

                if (columnsFound.length > 0) {
                    generalErrors.push(objectName);
                }                
            }
        }; 

        let showError = function (text) {
            new ConfirmDialogView({
                    model: new Model({
                        text: text,
                        title: 'Preview Report', 
                        width: '450', 
                        height: 'auto'
                    })
                }).render();
        };

        let getDataColumn = (model = null, columnData, columnsSource, findFieldsBy) => {
            let columns = !columnsSource ? model.get(columnData) : model.get(columnData)[columnsSource]; 
            let callBack = !columnsSource ? col => col.aggregation !== "" : 
                                col => col.Properties.aggregation === findFieldsBy;  

            let columnsFound = _.filter(columns, callBack);  

            return columnsFound;
        } 
       
        let reportingObjects = listService.objectList.toJS();

        _.forEach(reportingObjects, object => { 
                let model = object.model;

                if (model !== undefined) {
                    console.log("Model Object", model.attributes);
                    let dataSource = model.get("dataSourceId");
                    if (dataSource !== undefined) {
                        let factory = model.get("factoryKey");                        
                        let columnsFound = [];
                       
                        switch (factory) {
                            case "control_bar_chart": 
                            case "control_line_chart": 
                            case "control_pie_chart":
                            case "control_filter_input":  
                            case "control_filter_selector": 
                                columnsFound = getDataColumn(model, "Columns", "Column", "group")[0];  
                                validateFields(dataSource, columnsFound.Properties.fieldId, model.get("name"));
                                break;
                                 
                            case "control_crosstab": 
                                columnsFound = getDataColumn(model, "Columns", "Column", "group");  
                                validateCrossTabs(dataSource, columnsFound, model.get("name"));                                 
                                break;
                                    
                            case "control_data_grid":
                            case "control_data_list":
                                columnsFound = getDataColumn(model, "gridData", "", "");   

                                if (!columnsFound || !columnsFound.length) {
                                    gridErrors.push(model.get("name"));
                                } 

                                validateCrossTabs(dataSource, columnsFound, model.get("name"), true);
                                break;                             
                        }
                    }
                }
            });  

        let text = "An error has occured. <br><br>";  
        if (gridErrors.length > 0) {
            text += `There must be at least one column for the report object!:
                     <br><br>` + gridErrors.join("<br>");            
        }
        else if (generalErrors.length > 0) {
            text = `The following reporting object(s) do not have a field specified:
                     <br><br>` + generalErrors.join("<br>");            
        }

        let thereWereErros = generalErrors.length !== 0 || gridErrors.length !== 0;

        if (thereWereErros) {
            showError(text); 
        }  

        return thereWereErros;
    }
 

    //================================================================================
    // Saves the current editor report, as defined by listService state
    //================================================================================
    saveReport(ev, preview, debug = false, context = null, publish = false) {

        return new Promise((resolve, reject) => {

            let currentReport = listService.currentForm;

            const self = this || context;

            if (currentReport.model.get('title') === currentReport.model.get('name')) {
                currentReport.model.set('title', 'null', { silent: true });
            }
            currentReport.model.set('isYodaFile', true, { silent: true });
            const isRecoverySave = listService.isRecoverySave;

            self.updateAppName().then(response => {
                formSaveService.saveCurrentReport({ isNewVersion: false }).then(msg => {
                    if (!isRecoverySave) {
                        undoService.clearChangeTracker();
                        if (!publish) {
                            notificationService.success(msg);
                            self.showDebugOrPreview(preview, debug);
                        } else {
                            self.publishReport();
                        }
                    }
                    resolve();
                }, (errInfo) => {
                    if (parseInt(errInfo[1]) === 16) {

                        let confirmText = 'You cannot save over a published version <br /><br />';
                        confirmText += 'Would you like to save your changes as a new version?';

                        const confirmView = new ConfirmDialogView({
                            model: new Model({
                                text: confirmText,
                                success: () => {
                                    self.saveReportNewVersion(null, publish)
                                    .then(resolve) 
                                    .catch(reject);;
                                },
                                cancel: () => {
                                    reject(new Error("Save cancelled by user."));
                                },
                                title: 'Report already published'
                            })
                        });

                        confirmView.render();

                    } else {

                        if (!isRecoverySave) {
                            notificationService.error(errInfo[0]);
                        }
                        reject(errInfo);
                    }
                });
            }).catch(reject);
        })
    }

    saveReportNewVersion(callback, publish) {
        return new Promise((resolve, reject) => {
            let currentReport = listService.currentForm;
            currentReport.model.set('isYodaFile', true, { silent: true });
            const self = this;

            formSaveService.saveCurrentReport({ isNewVersion: true }).then(msg => {
                if (!publish) {
                    notificationService.success(msg);
                }

                const version = msg.split(" ")[2];
                const isPublished = util.isTrue(listService.dashboardLayout.mainPanelView.model.get("IsDeployed"));
                util.updateAppReportVersion(version, isPublished, false);

                undoService.clearChangeTracker();
                resolve();
                if (!publish) {
                    if (callback) {
                        window.setTimeout(callback, 1000);
                    }
                } else {
                    self.publishReport();
                }
               
            }, (errMsg) => {
                reject(errMsg);
                notificationService.error(errMsg);
            });
        });
    }

    saveReportAsNew() {
        let currentReport = listService.currentForm;
        currentReport.model.set('isYodaFile',true,{silent:true});
        const self = this;
        
        formSaveService.saveCurrentReportAsNew().then( (result) =>{
            notificationService.success( result.msg );
            util.setAppNewName(result.name);
        }, ( errMsg ) =>{
            notificationService.error( errMsg );
        });
        
    }
}

export default BaseMenuView;
